import { dashboardGuard } from '../guards';

import settingsRoutes from './settings';

import Dashboard from '@/views/Dashboard.vue';
import Home from '@/views/Dashboard/Home.vue';
import Tools from '@/views/Dashboard/Tools.vue';
import LicenseKeys from '@/views/Dashboard/LicenseKeys.vue';
import Analytics from '@/views/Dashboard/Analytics.vue';
import Integrations from '@/views/Dashboard/Integrations.vue';
import Library from '@/views/Dashboard/Library.vue';
import Community from '@/views/Dashboard/Community.vue';
import Offboarding from '@/views/Dashboard/Offboarding.vue';
import SuspendedUser from '@/views/Dashboard/SuspendedUser.vue';

export default [
    {
        path: '/',
        component: Dashboard,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: '',
                component: Home,
                meta: {
                    title: 'Dashboard',
                },
            },
            {
                path: 'tools',
                component: Tools,
                meta: {
                    title: 'Tools',
                },
            },
            {
                path: 'license-keys',
                component: LicenseKeys,
                meta: {
                    title: 'License Keys',
                },
            },
            {
                path: 'analytics',
                component: Analytics,
                meta: {
                    title: 'Analytics',
                },
            },
            {
                path: 'integrations',
                component: Integrations,
                meta: {
                    title: 'Integrations',
                },
            },
            {
                path: 'library',
                component: Library,
                meta: {
                    title: 'Library',
                    proUser: true,
                },
            },
            {
                path: 'community',
                component: Community,
                meta: {
                    title: 'Community',
                    proUser: true,
                },
            },
            {
                path: 'offboarding',
                component: Offboarding,
                meta: {
                    title: 'Offboarding',
                    proUser: true,
                    offboarding: true,
                },
            },
            {
                path: 'suspended-user',
                component: SuspendedUser,
                meta: {
                    title: 'SuspendedUser',
                    proUser: true,
                },
            },
            ...settingsRoutes,
        ],
        beforeEnter: dashboardGuard,
    },
];
